import React, { useEffect, useState } from 'react'
import './form.css'
import { validateFunctionalForm } from '../../utils';
import { v2_ship_owners } from '../../actions/v2/masterData';
import { NumberFormatBase } from 'react-number-format';
import { v2_ships } from '../../actions/v2/projectAndVessel';
import moment from 'moment';

const Form = ({ onCancel, onSubmit, data }) => {

    const [state, setState] = useState({
        appraiseeName: { name: 'appraiseeName', value: '', isRequired: false, error: '', editable: false },
        appraiseeDesignation: { name: 'appraiseeDesignation', value: '', isRequired: false, error: '', editable: false },
        dateOfReport: { name: 'dateOfReport', value: moment().format('YYYY-MM-DD') || '', isRequired: true, error: '', editable: true },
        siteOffice: { name: 'siteOffice', value: '', isRequired: false, error: '', editable: false },
        owner: { name: 'owner', value: '', options: [], isRequired: true, error: '', editable: true },
        hullNo: { name: 'hullNo', value: '', options: [], isRequired: true, error: '', editable: true },

        // Evaluation scores (1-5)
        knowledgeSkill: { name: 'knowledgeSkill', value: '', isRequired: true, error: '', editable: true },
        applicationOfKnowledge: { name: 'applicationOfKnowledge', value: '', isRequired: true, error: '', editable: true },
        leadershipResponsibility: { name: 'leadershipResponsibility', value: '', isRequired: true, error: '', editable: true },
        teamwork: { name: 'teamwork', value: '', isRequired: true, error: '', editable: true },
        initiativeMotivation: { name: 'initiativeMotivation', value: '', isRequired: true, error: '', editable: true },
        communicationSkills: { name: 'communicationSkills', value: '', isRequired: true, error: '', editable: true },
        safetyAttitude: { name: 'safetyAttitude', value: '', isRequired: true, error: '', editable: true },
        planningOrganizing: { name: 'planningOrganizing', value: '', isRequired: true, error: '', editable: true },
        prioritizingTimeMgmt: { name: 'prioritizingTimeMgmt', value: '', isRequired: true, error: '', editable: true },
        problemSolving: { name: 'problemSolving', value: '', isRequired: true, error: '', editable: true },
        emergencyResponse: { name: 'emergencyResponse', value: '', isRequired: true, error: '', editable: true },
        selfLearning: { name: 'selfLearning', value: '', isRequired: true, error: '', editable: true },
        personalConduct: { name: 'personalConduct', value: '', isRequired: true, error: '', editable: true },
        interactionWithClients: { name: 'interactionWithClients', value: '', isRequired: true, error: '', editable: true },
        proactiveApproach: { name: 'proactiveApproach', value: '', isRequired: true, error: '', editable: true },
        budgetingCostControl: { name: 'budgetingCostControl', value: '', isRequired: true, error: '', editable: true },
        resultOriented: { name: 'resultOriented', value: '', isRequired: true, error: '', editable: true },
        rulesRegulationsCompliance: { name: 'rulesRegulationsCompliance', value: '', isRequired: true, error: '', editable: true },
        documentControl: { name: 'documentControl', value: '', isRequired: true, error: '', editable: true },
        promotionSuitability: { name: 'promotionSuitability', value: '', isRequired: true, error: '', editable: true },
        futureEmploymentRecommendation: { name: 'futureEmploymentRecommendation', value: '', isRequired: true, error: '', editable: true },
        grade: { name: 'grade', value: '', isRequired: false, error: '', editable: false },

    });


    useEffect(() => {
        if (data) {
            const { exists, data: detail } = data;

            if (!exists && detail) {
                // Prefill only basic info if form doesn't exist
                setState(prev => ({
                    ...prev,
                    appraiseeName: {
                        ...prev.appraiseeName,
                        value: detail.FULL_NAME || '',
                        editable: false,
                    },
                    appraiseeDesignation: {
                        ...prev.appraiseeDesignation,
                        value: detail.DESIGNATION_NAME || '',
                        editable: false,
                    },
                    siteOffice: {
                        ...prev.siteOffice,
                        value: detail.SITE_LOCATION_NAME || '',
                        editable: false,
                    }
                }));
            } else if (exists && detail) {
                // Populate entire form and make fields non-editable
                setState(prev => ({
                    ...prev,
                    appraiseeName: { ...prev.appraiseeName, value: detail.APPRAISEE_NAME || '', editable: false },
                    appraiseeDesignation: { ...prev.appraiseeDesignation, value: detail.APPRAISEE_DESIGNATION || '', editable: false },
                    dateOfReport: { ...prev.dateOfReport, value: detail.DATE_OF_REPORT || '', editable: false },
                    siteOffice: { ...prev.siteOffice, value: detail.SITE_OFFICE || '', editable: false },
                    owner: { ...prev.owner, value: detail.OWNER || '', editable: false },
                    hullNo: { ...prev.hullNo, value: detail.HULL_NO || '', editable: false },

                    knowledgeSkill: { ...prev.knowledgeSkill, value: detail.KNOWLEDGE_SKILL || '', editable: false },
                    applicationOfKnowledge: { ...prev.applicationOfKnowledge, value: detail.APPLICATION_OF_KNOWLEDGE || '', editable: false },
                    leadershipResponsibility: { ...prev.leadershipResponsibility, value: detail.LEADERSHIP_RESPONSIBILITY || '', editable: false },
                    teamwork: { ...prev.teamwork, value: detail.TEAMWORK || '', editable: false },
                    initiativeMotivation: { ...prev.initiativeMotivation, value: detail.INITIATIVE_MOTIVATION || '', editable: false },
                    communicationSkills: { ...prev.communicationSkills, value: detail.COMMUNICATION_SKILLS || '', editable: false },
                    safetyAttitude: { ...prev.safetyAttitude, value: detail.SAFETY_ATTITUDE || '', editable: false },
                    planningOrganizing: { ...prev.planningOrganizing, value: detail.PLANNING_ORGANIZING || '', editable: false },
                    prioritizingTimeMgmt: { ...prev.prioritizingTimeMgmt, value: detail.PRIORITIZING_TIME_MGMT || '', editable: false },
                    problemSolving: { ...prev.problemSolving, value: detail.PROBLEM_SOLVING || '', editable: false },
                    emergencyResponse: { ...prev.emergencyResponse, value: detail.EMERGENCY_RESPONSE || '', editable: false },
                    selfLearning: { ...prev.selfLearning, value: detail.SELF_LEARNING || '', editable: false },
                    personalConduct: { ...prev.personalConduct, value: detail.PERSONAL_CONDUCT || '', editable: false },
                    interactionWithClients: { ...prev.interactionWithClients, value: detail.INTERACTION_WITH_CLIENTS || '', editable: false },
                    proactiveApproach: { ...prev.proactiveApproach, value: detail.PROACTIVE_APPROACH || '', editable: false },
                    budgetingCostControl: { ...prev.budgetingCostControl, value: detail.BUDGETING_COST_CONTROL || '', editable: false },
                    resultOriented: { ...prev.resultOriented, value: detail.RESULT_ORIENTED || '', editable: false },
                    rulesRegulationsCompliance: { ...prev.rulesRegulationsCompliance, value: detail.RULES_REGULATIONS_COMPLIANCE || '', editable: false },
                    documentControl: { ...prev.documentControl, value: detail.DOCUMENT_CONTROL || '', editable: false },
                    promotionSuitability: { ...prev.promotionSuitability, value: detail.PROMOTION_SUITABILITY || '', editable: false },
                    futureEmploymentRecommendation: { ...prev.futureEmploymentRecommendation, value: detail.FUTURE_EMPLOYMENT_RECOMMENDATION || '', editable: false },
                }));
            }
        }
    }, [data]);

    useEffect(() => {
        v2_ship_owners().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    owner: {
                        ...prev.owner,
                        options: res.result || [],
                    }
                }));
            }
        })
    }, [])
    useEffect(() => {
        if (state.owner.value) {
            v2_ships(state.owner.value, null).then((res) => {
                if (res.status) {
                    setState(prev => ({
                        ...prev,
                        hullNo: {
                            ...prev.hullNo,
                            options: res.result || [],
                            value: prev.hullNo.value
                        }
                    }));
                }
            })
        }
        else {
            v2_ships().then((res) => {
                if (res.status) {
                    setState(prev => ({
                        ...prev,
                        hullNo: {
                            ...prev.hullNo,
                            options: res.result || [],
                        }
                    }));
                }
            });
        }

    }, [state.owner.value])



    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;
        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: val,
                error: prev[name].isRequired && !val ? 'This field is required' : ''
            }
        }));
    };

    const handleSubmit = () => {
        if (validateFunctionalForm(state, setState)) {
            const model = Object.fromEntries(
                Object.entries(state).map(([key, field]) => [key, field.value])
            );

            // If editing an existing form, include the ID
            if (data?.ID) {
                model.id = data.ID;
            }

            onSubmit(model);
        }
    };


    const handleCancel = () => {
        onCancel?.();
    };
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        {/* <div className="row">
                            <div className="col-md-12">
                                <div className="form-title-bx bg-grd">
                                    <h4>Appraisal Report - Site Manager & Inspector</h4>
                                </div>
                            </div>
                        </div> */}
                        <div className="appraisal-report-table-responsive">
                            <table className="headr-table bg-grd" cellSpacing={0}>
                                <tbody>
                                    <tr style={{ height: "23pt" }}>
                                        <td>
                                            <p className="s1">
                                                Name : <span>{state.appraiseeName.value}</span>
                                            </p>
                                        </td>
                                        <td style={{ width: '330px' }}>
                                            <p className="s1">
                                                Designation : <span>{state.appraiseeDesignation.value}</span>
                                            </p>
                                        </td>
                                        <td style={{ width: '350px' }}>
                                            <div className="d-flex align-items-center gap-2">
                                                <label className="mb-0 fw-semibold">Date of Report {state.dateOfReport.isRequired  &&<span className='text-danger'>*</span>}</label>
                                                <input
                                                    className={state.dateOfReport.error && !state.dateOfReport.value ? "form-control is-invalid" : "form-control"}
                                                    type="date"
                                                    name={state.dateOfReport.name}
                                                    value={state.dateOfReport.value}
                                                    onChange={handleChange}
                                                    readOnly={!state.dateOfReport.editable} // Optional
                                                    style={{
                                                        maxWidth: '200px', backgroundColor: 'rgb(229 240 248)', border: 'none',
                                                        boxShadow: 'none',
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        color: '#7d7d7d',
                                                    }}
                                                />
                                            </div>
                                        </td>

                                    </tr>
                                    <tr style={{ height: "22pt" }}>
                                        <td>
                                            <p className="s1">
                                                Site Office : <span>{state.siteOffice.value}</span>
                                            </p>
                                        </td>
                                        <td>
                                            <div className="s1 d-flex align-items-center gap-3">
                                                <label className="mb-0 fw-semibold">Owner </label>
                                                <select className={state.owner.error && !state.owner.value ? "form-select is-invalid" : "form-select"}
                                                    style={{
                                                        maxWidth: '250px', backgroundColor: 'rgb(229 240 248)', border: 'none',
                                                        boxShadow: 'none',
                                                        marginRight: '10px',
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        color: '#7d7d7d',

                                                    }}
                                                    name={state.owner.name}
                                                    value={state.owner.value}

                                                    onChange={handleChange}
                                                    disabled={!state.owner.editable}

                                                >
                                                    <option value={''}>Select Owner</option>
                                                    {state.owner.options.map((item) => {
                                                        return (<option key={item.ID} value={item.ID}>{item.OWNER_NAME}</option>)
                                                    })}
                                                </select>

                                            </div>
                                        </td>
                                        <td>
                                            <div className="s1 d-flex align-items-center gap-3">
                                                <label className="mb-0 fw-semibold">Hull No {state.hullNo.isRequired && <span className='text-danger'>*</span>}</label>
                                                
                                                <select className={state.hullNo.error && !state.hullNo.value ? "form-select is-invalid" : "form-select"}
                                                    style={{
                                                        maxWidth:'250px', backgroundColor: 'rgb(229 240 248)'
                                                        , border: 'none',
                                                        boxShadow: 'none',
                                                        fontSize:'14px',
                                                        fontWeight:'500',
                                                        color:'#7d7d7d',
                                                    }}
                                                    name={state.hullNo.name}
                                                    value={state.hullNo.value}
                                                    onChange={handleChange}
                                                    disabled={!state.hullNo.editable}

                                                >
                                                    <option value={''}>Select Hull</option>
                                                    {state.hullNo.options.map((item) => {
                                                        return (<option key={item.ID} value={item.ID}>{item.HULL_NUMBER}</option>)
                                                    })}
                                                </select>
                                            </div>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                            <table className="assessment-table" cellSpacing={0}>
                                <tbody>
                                    <tr style={{ height: "28pt" }}>
                                        <td className="hd-s1" colSpan={5}>
                                            <p className='ps-2'>ASSESSMENT</p>
                                        </td>
                                        <td className="hd-s2">
                                            <p className='text-center'>
                                                <a name="bookmark0">‌</a>Appraiser’s
                                                <br /> Evaluation (1 to 5)<a name="bookmark1">‌</a>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="td-s1">
                                            <p className="s1">1.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Knowledge and Skill</p>
                                            <p className="s2">
                                                Has adequate knowledge and skills to perform the job
                                                properly
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                className={state.knowledgeSkill.error && !state.knowledgeSkill.value ? "form-control is-invalid" : "form-control"}

                                                placeholder="Rate (1-5)"
                                                name={state.knowledgeSkill.name}
                                                value={state.knowledgeSkill.value}
                                                onChange={handleChange}
                                                allowNegative={false}
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                            />

                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="td-s1">
                                            <p className="s1">2.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Application of Knowledge &amp; Skills</p>
                                            <p className="s3">
                                                Committed to ensure compliance of Technical Specification,
                                                Approved Drawings/ its approval comments.
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase

                                                className={state.applicationOfKnowledge.error && !state.applicationOfKnowledge.value ? "form-control is-invalid" : "form-control"}

                                                defaultValue=""
                                                name={state.applicationOfKnowledge.name}
                                                value={state.applicationOfKnowledge.value}
                                                onChange={handleChange}
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "35pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">3.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">
                                                Leadership &amp; Sense of Responsibility
                                            </p>
                                            <p className="s3">
                                                Motivates and leads by example, is able to make rational
                                                decisions and can be depended upon.
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                className={state.leadershipResponsibility.error && !state.leadershipResponsibility.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.leadershipResponsibility.name}
                                                value={state.leadershipResponsibility.value}
                                                onChange={handleChange}
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "34pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">4.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Teamwork</p>
                                            <p className="s3">
                                                Works well with others in an enthusiastic manner, assists,
                                                cooperates &amp; shares information with colleagues.
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                className={state.teamwork.error && !state.teamwork.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.teamwork.name}
                                                value={state.teamwork.value}
                                                onChange={handleChange}
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "23pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">5.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Initiative &amp; Motivation</p>
                                            <p className="s3">
                                                Willing to take additional responsibility. Strongly
                                                motivated to do the job well.
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.initiativeMotivation.error && !state.initiativeMotivation.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.initiativeMotivation.name}
                                                value={state.initiativeMotivation.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "26pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">6.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Communication and Interpersonal Skills</p>
                                            <p className="s3">
                                                Ability to listen &amp; express oneself clearly and
                                                effectively.
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.communicationSkills.error && !state.communicationSkills.value ? "form-control is-invalid" : "form-control"}
                                                defaultValue=""
                                                name={state.communicationSkills.name}
                                                value={state.communicationSkills.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "34pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">7.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">
                                                Attitude towards Safety, Health &amp; Environment
                                            </p>
                                            <p className="s3">
                                                Takes interest in Company’s QHSE system and follows safe
                                                working practices at all times.
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.safetyAttitude.error && !state.safetyAttitude.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.safetyAttitude.name}
                                                value={state.safetyAttitude.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "34pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">8.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">
                                                Planning, Organizing &amp; Delegating Skills
                                            </p>
                                            <p className="s3">
                                                Sets clear goals, makes plans in advance, delegates tasks
                                                appropriately and ensures they are completed within the
                                                stipulated time.
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.planningOrganizing.error && !state.planningOrganizing.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.planningOrganizing.name}
                                                value={state.planningOrganizing.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "35pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">9.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">
                                                Ability to Prioritize Tasks/ Time Management
                                            </p>
                                            <p className="s3">
                                                Has understanding of critical versus non critical tasks,
                                                sets priorities for work/ activities.
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.prioritizingTimeMgmt.error && !state.prioritizingTimeMgmt.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.prioritizingTimeMgmt.name}
                                                value={state.prioritizingTimeMgmt.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "34pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">10.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">
                                                Problem Solving and Rational Thinking Ability
                                            </p>
                                            <p className="s3">
                                                Ability to analyze situation logically, identifies possible
                                                causes and develops workable solutions.
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.problemSolving.error && !state.problemSolving.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.problemSolving.name}
                                                value={state.problemSolving.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "34pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">11.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">
                                                Emergency Response / Behavior under Stress
                                            </p>
                                            <p className="s3">
                                                Copes well with work pressures, is attentive to changes and
                                                quick to respond in an emergency situation.
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.emergencyResponse.error && !state.emergencyResponse.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.emergencyResponse.name}
                                                value={state.emergencyResponse.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "34pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">12.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Ability to Self Learn</p>
                                            <p className="s3">
                                                Takes keen interest in upgrading skills by reading ,
                                                observing and is able to learn from own / others experience.
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.selfLearning.error && !state.selfLearning.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.selfLearning.name}
                                                value={state.selfLearning.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "24pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">13.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Personal Conduct</p>
                                            <p className="s3">General Appearance, Manners and Conduct.</p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.personalConduct.error && !state.personalConduct.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.personalConduct.name}
                                                value={state.personalConduct.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "26pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">14.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Interaction with Client/Owner/Builder</p>
                                            <p className="s3">Gives a favourable impression</p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.interactionWithClients.error && !state.interactionWithClients.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.interactionWithClients.name}
                                                value={state.interactionWithClients.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "34pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">15.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Proactive Approach</p>
                                            <p className="s3">
                                                Acting in advance to deal with an expected difficulty &amp;
                                                takes good anticipatory action
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.proactiveApproach.error && !state.proactiveApproach.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.proactiveApproach.name}
                                                value={state.proactiveApproach.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "35pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">16.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Budgeting / Cost Control</p>
                                            <p className="s3">
                                                Understands relationship between cost control and
                                                efficiency.
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.budgetingCostControl.error && !state.budgetingCostControl.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.budgetingCostControl.name}
                                                value={state.budgetingCostControl.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "35pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">17.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Focused &amp; Result Oriented</p>
                                            <p className="s3">
                                                Has a consistent approach to achieve the most optimum result
                                                with available resources.
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.resultOriented.error && !state.resultOriented.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.resultOriented.name}
                                                value={state.resultOriented.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "35pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">18.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Rules, Regulations</p>
                                            <p className="s3">
                                                Good understanding of regulations and requirements for
                                                compliance with regulations
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.rulesRegulationsCompliance.error && !state.rulesRegulationsCompliance.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.rulesRegulationsCompliance.name}
                                                value={state.rulesRegulationsCompliance.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "35pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">19.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Document Control</p>
                                            <p className="s3">
                                                Ability to document observations systematically and its
                                                follow up.
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.documentControl.error && !state.documentControl.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.documentControl.name}
                                                value={state.documentControl.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "35pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">20.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Suitability for promotion to next rank</p>
                                            <p className="s3">
                                                Capable of shouldering more responsibility
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.promotionSuitability.error && !state.promotionSuitability.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.promotionSuitability.name}
                                                value={state.promotionSuitability.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                    <tr style={{ height: "35pt" }}>
                                        <td className="td-s1">
                                            <p className="s1">21.</p>
                                        </td>
                                        <td className="td-s2" colSpan={4}>
                                            <p className="s1">Recommended for future employment</p>
                                            <p className="s3">
                                                He can be hired for next available newbiulding project of
                                                OSS
                                            </p>
                                        </td>
                                        <td className="td-s3">
                                            <NumberFormatBase
                                                isAllowed={(values) => {
                                                    const { floatValue, value } = values;
                                                    return value === '' || (floatValue >= 1 && floatValue <= 5);
                                                }}
                                                placeholder="Rate (1-5)"
                                                className={state.futureEmploymentRecommendation.error && !state.futureEmploymentRecommendation.value ? "form-control is-invalid" : "form-control"}


                                                defaultValue=""
                                                name={state.futureEmploymentRecommendation.name}
                                                value={state.futureEmploymentRecommendation.value}
                                                onChange={handleChange}
                                                min={1}
                                                max={5}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="gard-table">
                                <tbody>
                                    <tr className="gard-row">
                                        <td>
                                            <p className="s4">Grade </p>
                                        </td>
                                        <td>
                                            <label className="s4 d-flex align-items-center">
                                                1. Poor&nbsp;&nbsp;
                                                <input type="checkbox" className="form-check-input grade-cb-margin ms-2" />
                                            </label>
                                        </td>
                                        <td>
                                            <label className="s4 d-flex align-items-center">
                                                2. Average&nbsp;&nbsp;
                                                <input type="checkbox" className="form-check-input grade-cb-margin ms-2" />
                                            </label>
                                        </td>
                                        <td>
                                            <label className="s4 d-flex align-items-center">
                                              3. Good&nbsp;&nbsp;
                                                <input type="checkbox" className="form-check-input grade-cb-margin ms-2" />
                                            </label>
                                        </td>
                                        <td>
                                            <label className="s4 d-flex align-items-center">
                                                4. Very Good&nbsp;&nbsp;
                                                <input type="checkbox" className="form-check-input grade-cb-margin ms-2" />
                                            </label>
                                        </td>
                                        <td>
                                            <label className="s4 d-flex align-items-center">
                                                5. Exceptionally Good&nbsp;&nbsp;
                                                <input type="checkbox" className="form-check-input grade-cb-margin ms-2" />
                                            </label>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                            <table className="siganture-table" cellSpacing={0}>
                                <tbody>
                                    <tr className="sig-tr1-box">
                                        <td colSpan={3}>
                                            <p className="s1">
                                                (1) Comments of Person carrying out Appraisal
                                                (Site Manager)
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="sig-tr2-box">
                                        <td className="w400">
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                        <td className="w300">
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                        <td className="input-td">
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    defaultValue=""
                                                />
                                            </p>
                                            <p className="s2">Name</p>
                                        </td>
                                        <td className="w50">
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                        <td className="input-td pdr-30">
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    defaultValue=""
                                                />
                                            </p>
                                            <p className="s2">Signature</p>
                                        </td>
                                    </tr>
                                    <tr className="sig-tr1-box">
                                        <td colSpan={3}>
                                            <p className="s1">
                                                (2) Comments of Person carrying out the Appraisal Review
                                                (Project Manager)
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                    </tr>
                                    <tr className="sig-tr2-box">
                                        <td className="w400">
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                        <td className="w300">
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                        <td className="input-td">
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    defaultValue=""
                                                />
                                            </p>
                                            <p className="s2">Name</p>
                                        </td>
                                        <td className="w50">
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                        <td className="input-td pdr-30">
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    defaultValue=""
                                                />
                                            </p>
                                            <p className="s2">Signature</p>
                                        </td>
                                    </tr>
                                    {/* <tr className="sig-tr1-box">
                                        <td colSpan={3}>
                                            <p className="s1">(3) Comments of Office In-charge</p>
                                        </td>
                                        <td>
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                    </tr> */}
                                    {/* <tr className="sig-tr2-box">
                                        <td className="w400">
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                        <td className="w300">
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                        <td className="input-td">
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    defaultValue=""
                                                />
                                            </p>
                                            <p className="s2">Name</p>
                                        </td>
                                        <td className="w50">
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                        <td className="input-td pdr-30">
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    defaultValue=""
                                                />
                                            </p>
                                            <p className="s2">Signature</p>
                                        </td>
                                    </tr> */}
                                    <tr className="sig-tr1-box">
                                        <td colSpan={4}>
                                            <p className="s1" />
                                        </td>
                                        <td>
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table>
                                <tbody>
                                    <tr className="sig-tr2-box">
                                        <td className="w50">
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                        <td className="input-td">
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    defaultValue=""
                                                />
                                            </p>
                                            <p className="s2">Date</p>
                                        </td>
                                        <td className="w50">
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                        <td className="input-td">
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    defaultValue=""
                                                />
                                            </p>
                                            <p className="s2">Appraisee’s Signature</p>
                                        </td>
                                        <td className="w50">
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                        <td className="input-td">
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    defaultValue=""
                                                />
                                            </p>
                                            <p className="s2">Appraiser</p>
                                        </td>
                                        <td className="w50">
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                        <td className="input-td">
                                            <p className="s1">
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    defaultValue=""
                                                />
                                            </p>
                                            <p className="s2">Signature</p>
                                        </td>
                                        <td className="w50">
                                            <p>
                                                <br />
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="row mt-3">
                                <div className="col-lg-12 text-left ">
                                    <button
                                        type='button'
                                        onClick={() => { handleSubmit() }}
                                        className="btn btn-success"
                                        style={{
                                            backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                            borderColor: "#2b5a7e"
                                        }}
                                    >
                                        Submit
                                    </button>
                                    <button
                                        type="reset"
                                        className="btn btn-danger ms-3"
                                        style={{
                                            backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                            borderColor: "#2b5a7e"
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Form
